import EventStatsItem from './EventStatsItem';

export default EventStatsItem;
